export const ROUTES = {
  home: "/",
  answers: "FAQ",
  terms: "terms-and-conditions",
  contact: "contact-us",
} as const;

export type Routes = typeof ROUTES;
export type RoutesKeys = keyof Routes;
